import _classnames from 'classnames';


/*
 * Map of aliased class names to actual styles
 */
const aliasToClassNamesMap = {
  '-flex-cc': 'flex items-center justify-center',
  '-inline-flex-cc': 'inline-flex items-center justify-center',
  '-abs-fill': 'absolute top-0 right-0 bottom-0 left-0',
  '-button': 'bg-transparent outline-0 bn pointer pa0 moa-ff-sans',
  '-outer-ph-rwd': 'ph3 ph4-m ph5-l',  // outer most ph for responsive

  '-inline-code': 'br1 bg-light-gray pa1',  // XXX: Change name to something else
  '-popover-frame': 'bg-white ba b--light-gray br2 shadow-faint',

  '-headline-base': 'moa-ff-sans f2-half fw4 dark-gray ma0',
  '-heading-base': 'moa-ff-sans f4 fw5 lh-title',
  '-typography-base': 'moa-ff-ng f4 fw3 lh-copy',
  '-button-reset': 'bg-transparent outline-0 bn pointer pa0',
};

/*
 * mixClasses
 *
 * Reference: https://github.com/chibicode/react-functional-css-protips
 */
const mixClasses = (...args) => {
  return _classnames(...args).split(/\s+/).map(className => (
    aliasToClassNamesMap[className] || className
  )).join(' ');
};


/*
 * mixStyles
 */
const mixStyles = (...styles) => {
  return Object.assign({}, ...styles);
};



export {
  mixClasses,
  mixStyles,
};



// WEBPACK FOOTER //
// ./src/helpers/styleHelper.js